import React from "react";
import Navbar from "./components/Navbar";
import "./styles/global.css";
import Home from "./pages/HomePage";
import PostPage from "./pages/PostPage";
import { Route, Routes } from "react-router-dom";

export default function App() {
  return (
    <>
      <Navbar />
 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/post/:postId" element={<PostPage />} />
      </Routes>
    </>
  );
}
